import { ReactNode, useReducer } from 'react';
import ChartContext from './chartContext';
import chartReducer from './chartReducer';
import { ChartStateType } from './chartTypes';

type ChartStateProps = {
    children: ReactNode;
};

const initialState: ChartStateType = {
    selectedTradePair: null,
    tvWidget: null,
    isChartReady: false,
    isAdvancedMode: localStorage.getItem('advancedMode') === 'true',
    favouriteMarkets: JSON.parse(localStorage.getItem('favouriteMarkets') || '[]'),
};

const ChartState: React.FC<ChartStateProps> = ({ children }) => {
    const [state, dispatch] = useReducer(chartReducer, initialState);

    return (
        <ChartContext.Provider value={{ ...state, dispatch }}>
            {children}
        </ChartContext.Provider>
    );
};

export default ChartState;
